import axios from 'axios'
import { getParams } from 'utils/helpers'

export const apiCompanies = axios.create({
	baseURL: process.env.REACT_APP_BASE_API_COMPANIES,
	headers: {
		'Content-type': 'application/json',
	},
})

apiCompanies.interceptors.request.use(async (config: any) => {
	try {
		const { token } = await getParams()
		config.headers.Authorization = `Bearer ${token}`
	} catch (e) {
		console.log('Unable to Token', e)
	}
	return config
})
